import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-773c5f7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "campaign-page__header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "キャンペーン新規作成")
], -1))
const _hoisted_3 = { class: "grid-nogutter" }
const _hoisted_4 = { class: "col-12 py-0" }
const _hoisted_5 = { class: "list-none m-0 p-0" }
const _hoisted_6 = { class: "col-12 md:col-6 mt-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "flex font-normal mb-1"
}, [
  /*#__PURE__*/_createTextVNode("キャンペーン名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-2 red-required" }, "必須")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_9 = { class: "col-12 md:col-4 mt-0" }
const _hoisted_10 = { class: "col-12 md:col-4 mt-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "配信回数", -1))
const _hoisted_12 = { class: "field col-12 md:col-8 flex justify-content-end mt-8" }

import Message from "@/clinic/components/atoms/CustomPrimeVue/Message.vue";
import { get, set } from "@vueuse/core";
import { ref, reactive, onBeforeMount } from "vue";
import { ValidateError } from "async-validator";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "../../../constants/router.constants";
import Toast from "primevue/toast";
import Segments from "../components/segment.vue";
import Messages from "../components/message.vue";
import CampaignServices from "../../../services/campaign.services";
import { ICampaignSegments } from "@/clinic/typings/entities/campaign";
import { CampaignMessageOptions } from "@/clinic/typings/enums/campaign";
import axios from "axios";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";
import * as _ from "lodash";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const form = reactive({
  name: "",
  images: ref([]),
  messagesAttributes: ref([]),
  segmentsAttributes: ref([]),
});
const numberMessage = ref(2);
const store = useStore();
const toast = useToast();
const validateErrors = ref(false);
const validatePresent = value => {
  return get(validateErrors) && (value == "" || value == null);
};
const validates = () => {
  set(validateErrors, false);

  if (get(form.name) == "") {
    set(validateErrors, true);
  }

  return get(validateErrors);
};
const updateDataSegment = (data: any, index: number) => {
  const segmentsAttributes = form.segmentsAttributes as any[];
  if (segmentsAttributes[index]) {
    segmentsAttributes[index] = { ...get(data) };
  } else {
    segmentsAttributes.push({ ...get(data) });
  }
};

const updateDataMessage = (data: any, index: number) => {
  const messagesAttributes = form.messagesAttributes as any[];
  if (messagesAttributes[index]) {
    messagesAttributes[index] = { ...get(data) };
  } else {
    messagesAttributes.push({ ...get(data) });
  }
};

const formRef = ref<HTMLFormElement>();
const pass = ref(false);
const errorFields = ref<{ [key: string]: ValidateError | ValidateError[] }>();
const errors = ref<ValidateError[]>([]);
const segments = ref<ICampaignSegments[] | null>(null);
const numberSegment = ref(1);
const addFormSegment = async () => {
  numberSegment.value += 1;
};
const loadSegments = async () => {
  const { data } = await CampaignServices.getCampaignSegments();
  const segmentsData = get(data) as unknown as ICampaignSegments[];
  set(segments, get(segmentsData));
};
const saveAsDraft = async () => await onSubmit(true);
const onSubmit = async (draft = false) => {
  if (validates()) {
    return;
  }
  const channelId = await store.dispatch("authClient/getChannelIdCookie");
  const flatSegmentsAttributes = () => {
    const result = _.flatMap(get(form.segmentsAttributes), items => _.map(items, item => item));
    return JSON.parse(JSON.stringify(result));
  };
  const flatMessagesAttributes = () => {
    const res = form.messagesAttributes.map(({ images, ...data }) => {
      return data;
    });
    return JSON.parse(JSON.stringify(res));
  };
  const flatImages = () => {
    const res = form.messagesAttributes.filter(({ images }) => images.value);
    return res;
  };
  var formData = new FormData();
  formData.append("name", get(form.name));
  if (draft) {
    formData.append("draft", draft);
  }
  formData.append("messages_attributes", JSON.stringify([...get(flatMessagesAttributes())]) as any);
  formData.append("segments_attributes", JSON.stringify([...get(flatSegmentsAttributes())]) as any);
  formData.append("image[]", [...get(flatImages())] as any);
  await axios
    .post(ApiRouterConstants.API_CAMPAIGNS, formData, {
      params: { channel_id: channelId },
      headers: { Accept: "application/json" },
    })
    .then(() => {
      RouterUtils.goTo(RouterConstants.CAMPAIGN_ROUTER_NAME);
    })
    .catch(error => {
      if (error.response && error.response.data && error.response.data.errors) {
        toast.add({
          severity: "error",
          detail: error.response.data.errors.join("\n"),
          life: 3000,
        });
      }
    });
};
onBeforeMount(() => {
  loadSegments();
});

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        ref_key: "formRef",
        ref: formRef,
        class: "text-field",
        onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
      }, [
        _createElementVNode("div", _hoisted_4, [
          (!pass.value && errors.value?.length)
            ? (_openBlock(), _createBlock(Message, {
                key: 0,
                icon: "false",
                closable: false,
                severity: "error",
                sticky: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "pb-2",
                        key: index
                      }, _toDisplayString(error?.message), 1))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(InputText), {
            class: _normalizeClass(["flex border-round", { 'p-invalid': validatePresent(form.name) }]),
            modelValue: form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
            name: "name"
          }, null, 8, ["modelValue", "class"]),
          (validatePresent(form.name))
            ? (_openBlock(), _createElementBlock("small", _hoisted_8, " 必須項目です。 "))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberSegment.value, (number, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(Segments, {
              index: index,
              segments: _unref(get)(segments.value),
              onUpdateDate: updateDataSegment
            }, null, 8, ["index", "segments"])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(Button), {
            label: "追加",
            class: "p-button-light",
            onClick: addFormSegment
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_Dropdown, {
            modelValue: numberMessage.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((numberMessage).value = $event)),
            options: _unref(CampaignMessageOptions),
            optionLabel: "name",
            optionValue: "value",
            class: "mr-2 font-normal mt-3 shadow-none w-10rem"
          }, null, 8, ["modelValue", "options"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberMessage.value, (number, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-12 md:col-4 mt-0"
          }, [
            _createVNode(Messages, {
              index: index,
              number: number,
              onUpdateDataMessage: updateDataMessage
            }, null, 8, ["index", "number"])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(Button), {
            class: "btn-save-once mr-5",
            label: "一次保存",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (saveAsDraft()))
          }),
          _createVNode(_unref(Button), {
            class: "btn-submit ml-5",
            label: "キャンペーン配信を開始",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (onSubmit()))
          })
        ])
      ], 544)
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ]))
}
}

})